<nav class="fixed top-0 left-32 z-50 w-max" >
    <ul class="flex gap-3 px-10 pt-2 pb-6 overflow-y-auto">
        <li class="nav-item" *ngFor="let n of menuItems" (click)="select('main', n.title);" [ngClass]="{active: isPathActive(n.path),'flex-1 flex justify-end' : n.title=='Tutorial'}">
            <!-- Este es el link tipo con hijos pero uno solo -->
            <div *ngIf="showLength(n.submenu) == 1">
                <div class="" *ngFor="let child of n.submenu" [ngClass]="{active: isPathActive(child.path)}" (click)="select('main', child.title, $event);" >
                    <a class="group botones icon-solo w-10 h-10 overflow-visible {{child.badgeClass}}" (click)="redirect(false, child);(isMobile && showLength(n.submenu) == 1) && toggleService.comprimida = true">
                        <span [ngClass]="[child.icon]"></span>
                        <span class="z-20 font-owners px-2 flex items-center h-4 leading-none absolute textNav opacity-0 group-hover:opacity-100 bg-principal rounded-full uppercase text-xs -bottom-5 -translate-x-1/2 transition-opacity">{{n.title | translate}}</span>
                    </a>
                </div>
            </div>

            <!-- Este es el link principal -->
            <a (click)="redirect(false, n);(isMobile && n.submenu == 0) && toggleService.comprimida = true" class="group botones icon-solo w-10 h-10 overflow-visible {{n.badgeClass}}" *ngIf="showLength(n.submenu) != 1">
                <span [ngClass]="[n.icon]"></span>
                <span class="z-20 font-owners px-2 flex items-center h-4 leading-none absolute textNav opacity-0 group-hover:opacity-100 bg-principal rounded-full uppercase text-xs -bottom-5 -translate-x-1/2 transition-opacity">{{n.title | translate}}</span>
            </a>

            <!-- Este es el submenu -->
            <div class="panel absolute -bottom-4 z-30" *ngIf="showLength(n.submenu) >= 2">
                <ul class="flex gap-2 my-2 justify-center">
                    <li class="nav-item" *ngFor="let child of n.submenu" [ngClass]="{active: isPathActive(child.path)}" (click)="select('sub', child.title, $event);" >
                        <a class="py-1 px-2 items-center transition-colors duration-200 rounded-lg border-2 bg-white border-gris-claro-hover hover:bg-principal hover:text-white flex cursor-pointer {{child.badgeClass}}" (click)="redirect(true, child);isMobile && toggleService.comprimida = true">
                            <!-- <span class="inline-flex justify-center items-center"><span [ngClass]="[child.icon]"></span></span> -->
                            <span class="textNav">{{child.title | translate}}</span>
                        </a>
                    </li>
                </ul>
            </div>
            
        </li>
    </ul>
</nav>

<nav class="w-full relative">
    <ul class="flex gap-3 mt-2 mx-2 md:mx-6 px-3 py-3 overflow-y-auto rounded-lg shadow-base">
        <li class="nav-item" *ngFor="let n of menuItemsPasos; let i = index" (click)="select('main', n.title);" [ngClass]="{active: isPathActive(n.path),'flex-1 flex justify-end' : n.title=='Tutorial'}">
            <!-- Este es el link tipo con hijos pero uno solo -->
            <div *ngIf="showLength(n.submenu) == 1">
                <div class="" *ngFor="let child of n.submenu" [ngClass]="{active: isPathActive(child.path)}" (click)="select('main', child.title, $event);" >
                    <a class="botones btn-icon {{child.badgeClass}}" (click)="redirect(false, child);(isMobile && showLength(n.submenu) == 1) && toggleService.comprimida = true">
                        <span class="inline-flex justify-center items-center"><span [ngClass]="[child.icon]"></span></span>
                        <span class="textNav">{{child.title | translate}}</span>
                    </a>
                </div>
            </div>

            <!-- Este es el link principal -->
            <a (click)="redirect(false, n);(isMobile && n.submenu == 0) && toggleService.comprimida = true" class="botones btn-icon {{n.badgeClass}}" *ngIf="showLength(n.submenu) != 1 && n.title != 'Tutorial'">
                <span class="flex justify-center items-center p-1 w-8 h-8 bg-gris-claro border-2 text-gris-base-hover rounded-full"><span >{{i + 1}}</span></span>  <!--  <span [ngClass]="[n.icon]"></span> -->
                <span class="textNav">{{n.title | translate}}</span>
            </a>

            <!-- Este es el submenu -->
            <div class="panel" *ngIf="showLength(n.submenu) >= 2">
                <ul class="flex flex-col h-full">
                    <li class="nav-item" *ngFor="let child of n.submenu" [ngClass]="{active: isActive('sub', child.title)}" (click)="select('sub', child.title, $event);" >
                        <a class="botones cursor-pointer {{child.badgeClass}}" (click)="redirect(true, child);isMobile && toggleService.comprimida = true">
                            <span class="inline-flex justify-center items-center"><span [ngClass]="[child.icon]"></span></span>
                            <span class="textNav">{{child.title | translate}}</span>
                        </a>
                    </li>
                </ul>
            </div>
            
            <!-- Este es el link del tutorial -->
            <a *ngIf="n.title == 'Tutorial' && isRouteTutorial()" class="botones {{n.badgeClass}}" (click)="openCloseTutorial();"  >
                <!-- <span class="inline-flex justify-center items-center"><span [ngClass]="[n.icon]"></span></span> -->
                <span class="textNav hidden md:block">{{n.title | translate}}</span>
                <span class="textNav md:hidden block">?</span>
            </a>

        </li>
    </ul>
</nav>
<!-- /* original */ -->
<div *ngIf="false" class="flex bg-white navBotonera">

    <div class="flex items-center justify-center h-auto dark:bg-dark-botonera logoNav overflow-hidden">
        <div class="p-3 w-20">
            <img src="{{LOGO_PERSONALIZED}}" alt="">
        </div>
        <div *ngIf='ObjectKeys(store).length > 0' class="flex-1 w-36 md:w-32 mr-3 text-gris-base text-sm titleLogo truncate"><strong class="text-negro-principal dark:text-white text-base capitalize"> {{store.name}} </strong><br> {{store.country}} </div>
        <button class="w-14 h-14 relative transition-colors duration-200 hover:text-principal flex sm:hidden mr-1" (click)="toggleService.toggle()">
            <span class="w-6 h-0.5 bg-gris-base absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform rotate-45 origin-center"></span>
            <span class="w-6 h-0.5 bg-gris-base absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform -rotate-45 origin-center"></span>
        </button>
    </div>
    <nav class="w-full">
        <ul class="flex flex-col py-4 h-full">
            <li class="nav-item" *ngFor="let n of menuItems" (click)="select('main', n.title);" [ngClass]="{active: isActive('main', n.title)}">
                <div *ngIf="showLength(n.submenu) == 1">
                    <li class="" *ngFor="let child of n.submenu" [ngClass]="{active: isActive('main', child.title)}" (click)="select('main', child.title, $event);" >
                        <a class="botones {{child.badgeClass}}" (click)="redirect(false, child);(isMobile && showLength(n.submenu) == 1) && toggleService.comprimida = true">
                            <span class="inline-flex justify-center items-center"><span [ngClass]="[child.icon]"></span></span>
                            <span class="textNav">{{child.title | translate}}</span>
                        </a>
                    </li>
                </div>
                <!-- eliminar ultima parte del if cuando link funcione -->
                <a (click)="redirect(false, n);(isMobile && n.submenu == 0) && toggleService.comprimida = true" class="botones {{n.badgeClass}}" *ngIf="showLength(n.submenu) != 1 && n.title != 'Tutorial'">
                    <span class="inline-flex justify-center items-center"><span [ngClass]="[n.icon]"></span></span>
                    <span class="textNav">{{n.title | translate}}</span>
                </a>

                <!-- ocultar cuando el link funcione -->
                <p *ngIf="n.title == 'Tutorial'" class="botones {{n.badgeClass}}" >
                    <span class="inline-flex justify-center items-center"><span [ngClass]="[n.icon]"></span></span>
                    <span class="textNav">{{n.title | translate}}</span>
                </p>
                <div class="panel" *ngIf="showLength(n.submenu) >= 2">
                    <ul class="flex flex-col h-full">
                        <li class="nav-item" *ngFor="let child of n.submenu" [ngClass]="{active: isActive('sub', child.title)}" (click)="select('sub', child.title, $event);" >
                            <a class="botones cursor-pointer {{child.badgeClass}}" (click)="redirect(true, child);isMobile && toggleService.comprimida = true">
                                <span class="inline-flex justify-center items-center"><span [ngClass]="[child.icon]"></span></span>
                                <span class="textNav">{{child.title | translate}}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <li *ngIf="false" class="nav-item w-full mt-5 flex flex-row items-center">
                <a target="_blank" class="pl-4 mx-0 px-2 text-sm tracking-wide text-negro-secundario  hover:text-principal focus:text-principal truncate textNav whitespace-normal" [href]="store.domain"> 
                    {{domainText}}
                </a>
                <span (click)="copyURL()" class="block cursor-pointer icon-copy pr-4 text-xl hover:text-principal focus:text-principal justify-center items-center icon-copy"></span>
            </li>
            <li *ngIf="false" class="nav-item w-full mt-5 flex items-center justify-center flex-1 cursor-pointer">
                <img [src]="store.qr" id="imgQr" class="w-48" (click)="downloadQR()"*ngIf="store.qr != ''" />
            </li>
        </ul>
    </nav>
</div>